"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M250.5 359.8l107.7 65c7.9 4.8 17.7-2.3 15.6-11.3L345.3 291l95-82.3c6.9-6 3.3-17.5-6-18.3L309 179.8 260 64.4c-3.5-8.5-15.6-8.5-19.2 0l-49 115.4-125.1 10.6c-9.2.8-12.9 12.3-5.8 18.3l95 82.3-28.5 122.5c-2.1 9 7.7 16 15.6 11.2l107.5-64.9z"
  });
};

exports.default = _default;